export default __webpack_public_path__ + "static/media/009-dna.b5ae7475.svg";